import React from 'react';
import { ListItem, ListIcon } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';

var IconListItem = function IconListItem(_ref) {
  var children = _ref.children,
      iconColor = _ref.iconColor,
      iconName = _ref.iconName,
      iconPrefix = _ref.iconPrefix,
      _ref$textStyle = _ref.textStyle,
      textStyle = _ref$textStyle === void 0 ? 'p2' : _ref$textStyle;
  return /*#__PURE__*/React.createElement(ListItem, {
    textStyle: textStyle
  }, !!iconName && /*#__PURE__*/React.createElement(ListIcon, {
    className: "fa-li",
    textStyle: textStyle,
    as: Icon,
    iconName: iconName,
    prefix: iconPrefix,
    color: iconColor || 'icon-default'
  }), children);
};

IconListItem.displayName = "IconListItem";
export { IconListItem };